import React from 'react';
import styled from 'styled-components';
import { INVOICE_TYPES } from "../../../../Invoices/constants";

const Label = styled.span`
  padding: 2px 12px;
  text-align: center;
  border-radius: 5px;
  font-size: 12px;
  color: #fff;
  display: inline-block;
  white-space: nowrap;
  margin: 10px;
  width: 150px;
  background-color: ${props => {
  if (props.color) {
    return props.color;
  }

  if (props.type == INVOICE_TYPES.INVOICE) {
    return '#0083D5';
  }
  if (props.type == INVOICE_TYPES.CREDIT) {
    return 'rgba(162,31,31,0.8)';
  }

  return '#ffffff';
}};
`;

export const InvoiceTypeLabel = ({ children, type }) => {
  return (
    <Label type={type}>
      {children}
    </Label>
  );
};
